import React from 'react'
import Navbar from '../layouts/Navbar'
import Footer from '../Footer'

const TermsofUse = () => {
  return (
    <div>
      <Navbar/>
      TermsofUse
      <Footer/>
    </div>
  )
}

export default TermsofUse
